import { render, staticRenderFns } from "./relatePropertyDialog.vue?vue&type=template&id=dbefc5d0&scoped=true"
import script from "./relatePropertyDialog.vue?vue&type=script&lang=js"
export * from "./relatePropertyDialog.vue?vue&type=script&lang=js"
import style0 from "./relatePropertyDialog.vue?vue&type=style&index=0&id=dbefc5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbefc5d0",
  null
  
)

export default component.exports